paymentMethod:
  title: Payment Methods
  nameOnCard: Name on Card
  description: '{{ brand }} ending {{ lastDigits }}'
  brandAndExpiry: '{{ brand }} expiring {{ date }}'
  noneRegistered: No payment methods registered
  manage: Manage Payment Methods
  add: Add Payment Method
  added: Payment Method Added
  update: Update Payment Method
  updated: Payment method updated
  primary: Primary Card
  backup: Backup Card
  expiresSoon: Expires soon
  makePrimaryLabel: Make this my primary card
  makeBackupLabel: Make this my backup card

  errors:
    validationFailed:
      title: We were unable to verify those card details
      body: Double check that they are correct and try again, or use a different card.
    invalidZip:
      title: That ZIP / Postcode does not appear to be correct
      body: Double check, and try again.

permissionError:
  title: You don't have permission to perform this action.
  message: |
    <p>Your account does not have the required access level to complete this request. Only the <strong>Primary User</strong> or an <strong>Administrator</strong> can process this action.</p>
    <p>Please contact your Primary User, <strong>{{ companyPrincipalName }}</strong>, or reach out to us directly at <0>admin@charterindex.com</0> to have this processed on your behalf.</p>
